export const SUGGESTIONS_AD_CREATIVE_SLUG = 'text_template_five'
export const SUGGESTIONS_PRIMARY_TEXTS_SLUG = 'primary_texts'
export const SUGGESTIONS_HEADLINE_SLUG = 'headlines'
export const SUGGESTIONS_DESCRIPTIONS_SLUG = 'descriptions'
export const SUGGESTIONS_GOOGLE_AD = 'text_template_google'
